import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './GlobalNav.css';

/** 共通メニューの項目（並びは SCR-E-002 §1.2。ダッシュボードは 3 項目目） */
export const GLOBAL_NAV_ITEMS = [
    { key: 'mypage', to: '/', label: 'マイページ' },
    { key: 'opportunities', to: '/opportunities', label: '案件一覧' },
    { key: 'dashboard', to: '/dashboard', label: '📊 ダッシュボード' },
];

/** 案件一覧の中の画面（1 つの案件の中の画面のため、案件一覧を選んだ状態にする。SCR-E-002 §4.4） */
const OPPORTUNITY_CHILD_PREFIXES = ['/opportunity/', '/activity/', '/proposed_job/'];

/** 末尾の「/」の有無で見え方が変わらないように落とす（「/」そのものは残す） */
function trimTrailingSlash(pathname) {
    return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

/**
 * URL から、選んだ状態にする項目と aria-current の値を決める（SCR-E-002 §4.4 の表）
 *
 * どこから来たかでは決めない。同じ URL で見え方が変わると、再読み込み・URL の直接入力・「戻る」で
 * 選ばれる項目が変わるため。
 *
 * @param {string} pathname
 * @returns {{key: string, ariaCurrent: 'page' | 'true'} | null} どれも選ばない画面では null
 */
export function getCurrentNavItem(pathname) {
    const path = trimTrailingSlash(pathname);
    if (path === '/') return { key: 'mypage', ariaCurrent: 'page' };
    if (path === '/opportunities') return { key: 'opportunities', ariaCurrent: 'page' };
    if (path === '/dashboard') return { key: 'dashboard', ariaCurrent: 'page' };
    if (OPPORTUNITY_CHILD_PREFIXES.some((prefix) => path.startsWith(prefix))) {
        return { key: 'opportunities', ariaCurrent: 'true' };
    }
    return null;
}

/**
 * 共通メニュー（グローバルナビ。SCR-E-002 §4.4）
 *
 * ふだん・マウスを重ねたとき・選んでいる項目・キーボードで移ったときの見え方は GlobalNav.css。
 * 色をインラインの style で指定すると :hover の色が効かないため、クラスで指定する。
 */
function GlobalNav() {
    const { pathname } = useLocation();
    const current = getCurrentNavItem(pathname);

    return (
        <nav className="global-nav">
            {GLOBAL_NAV_ITEMS.map((item) => {
                const isCurrent = current?.key === item.key;
                return (
                    <Link
                        key={item.key}
                        to={item.to}
                        className={`global-nav-link${isCurrent ? ' global-nav-link-current' : ''}`}
                        aria-current={isCurrent ? current.ariaCurrent : undefined}
                    >
                        {item.label}
                    </Link>
                );
            })}
        </nav>
    );
}

export default GlobalNav;
